import {
    withProps,
    withPropsOnChange,
    compose,
} from 'recompose'
import { Combobox } from 'react-widgets'
import { connect } from 'react-redux'
import values from 'lodash/values'

import { getAvailableTransitions, dictSelectors } from '@infotech/mapissues'
import { getEntities } from '@infotech/lib-api-middleware'


const StatusEdit = compose(
    connect((state, { initialValues }) => {
        return {
            transitions: getAvailableTransitions(state, initialValues?.workflowId, initialValues?.statusId),
            statuses: dictSelectors.statuses(state),
            workflows: getEntities(state, `workflows`),
        }
    }),
    withPropsOnChange([`transitions`], ({ transitions, statuses, workflows, initialValues, formValues: { typeId } }) => {
        const dataIds = initialValues ? [initialValues?.statusId, ...(transitions ? transitions.map(t => t.to) : [])] 
            : values(workflows).find(w => w.issueCategories[0]?.id === typeId)?.statuses.filter(s => s.initial).map(s => s.statusId)
        const data = dataIds.map(id => ({
            id,
            name: statuses.find(s => s.id === id).name,
        }))
        return {
            data,
            textField: `name`,
            valueField: `id`,
            filter: `contains`,
        }
    }),
    withProps(({ input: { onChange, value } }) => ({
        onSelect: val => onChange(val.id),
        defaultValue: value,
    })),
)(Combobox)

export default StatusEdit